import PlayStoreLogo from "../../assets/play-store-logo.svg";
import AppStoreLogo from "../../assets/app-store-logo.svg";
import AppLogo from "../../assets/app-logo.png";
import ChatroomsSS from "../../assets/chatrooms.jpg";
import ExploreSS from "../../assets/explore.jpg";
import { useState } from "react";
import MobileInfoModal from "../../components/Modals/MobileInfoModal/MobileInfoModal";

const Mobile = () => {
  const [showInfo, setShowInfo] = useState(true);

  return (
    <>
      <MobileInfoModal isOpen={showInfo} onClose={() => setShowInfo(false)} />

      <div className="flex-1 bg-gradient-to-b from-white to-gray-100">
        <div className="container mx-auto px-4 py-8 md:py-12">
          {/* Hero Section */}
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12 mb-12">
            <div className="flex-1 text-center lg:text-left">
              <img src={AppLogo} alt="Noleyo Logo" className="w-24 h-24 md:w-32 md:h-32 mx-auto lg:mx-0 mb-6" />
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 md:mb-6">Connect with Your Activity Peers</h1>
              <p className="text-lg md:text-xl text-gray-600 mb-6 md:mb-8 max-w-xl">
                Hey everyone, Noleyo is an application where you connect with your activity peers!
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <a
                  href="https://play.google.com/store/apps/details?id=com.noleyo.noleyoapp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3 bg-red-600 text-white text-lg rounded-lg shadow-md hover:bg-red-500 transition flex items-center justify-center"
                >
                  <img src={PlayStoreLogo} alt="Google Play Store Logo" className="w-6 h-6 mr-2" />
                  Get it on Play Store
                </a>
                <a
                  href="https://apps.apple.com/us/app/noleyo/id6740176366"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3 bg-black text-white text-lg rounded-lg shadow-md hover:bg-gray-800 transition flex items-center justify-center"
                >
                  <img src={AppStoreLogo} alt="Apple App Store Logo" className="w-6 h-6 mr-2" />
                  Download on App Store
                </a>
              </div>
            </div>

            {/* App Screenshots */}
            <div className="flex-1">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto">
                <div className="relative">
                  <img
                    src={ChatroomsSS}
                    alt="Chatrooms Screenshot"
                    className="w-full rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="relative">
                  <img
                    src={ExploreSS}
                    alt="Explore Screenshot"
                    className="w-full rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-300"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Features Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-semibold mb-3">Connect</h3>
              <p className="text-gray-600">
                Choose your current activity — like a book you're reading or a film/show you're watching — and connect with others who are
                into the same thing.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-semibold mb-3">Chat</h3>
              <p className="text-gray-600">
                Join or create chatrooms based on shared interests and dive into conversations with like-minded people in real time.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-semibold mb-3">Explore</h3>
              <p className="text-gray-600">
                Browse what others are currently reading or watching and discover new activities that match your vibe.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Mobile;
